import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";

export default function AuthCallback() {
  const processed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { completeLogin } = useApp();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    const target = location.pathname + location.search;
    completeLogin(sessionId)
      .then((user) => toast.success(`Signed in as ${user.name || user.email}`))
      .catch(() => toast.error("Google sign-in failed. Please try again."))
      .finally(() => navigate(target, { replace: true }));
  }, [completeLogin, location.pathname, location.search, navigate]);

  return <div className="min-h-screen bg-[#060913]" data-testid="auth-callback" />;
}
